import { TalPreparationToolsScreen } from "types";
import { createScreen } from "../../../../utils/createScreen";

export const TalPreparationToolsDefinition = createScreen({
  name: TalPreparationToolsScreen,
  path: "/tal-tools",
  routePath: ["/tal-tools"],
  accessPath: "talPreparationTools",
});
